/**
 * @generated SignedSource<<2d9c81a46397b37bf58a96fbc75cde07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "webhookService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "step3WebhookServiceQuery",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "step3WebhookServiceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2cb89ed5fb95c410488d635cb1ceff61",
    "id": null,
    "metadata": {},
    "name": "step3WebhookServiceQuery",
    "operationKind": "mutation",
    "text": "mutation step3WebhookServiceQuery(\n  $request: WebhookServiceRequestInput\n) {\n  webhookService(request: $request) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "9db7544fc5c78e5ddbffec2145019e0c";

module.exports = node;
